import { forwardRef } from "react";
import { FormControl, FormErrorMessage, Select } from "@chakra-ui/react";
import { getObjValueFromPath } from "utils";
import EsgFormLabel from "./EsgFormLabel";

/**
 * Note: Different inputs and outputs to FormMultiSelect!! 
 * options are passed as child elements rather than as a prop.
 */
function FormSelect(
  { children, label, name, id = name, errors, controlProps, maxInlineSize, title, placeholder, multiple, color, ...rest },
  ref
) {
  const error = errors && getObjValueFromPath(name, errors);
  return (
    <FormControl
      isInvalid={error}
      maxInlineSize={maxInlineSize ? maxInlineSize : { base: "full", lg: "xs" }}
      minInlineSize="0"
      {...controlProps}
    >
      {label && (
        <EsgFormLabel
          htmlFor={id}
          color={color}
        >
          {label}
        </EsgFormLabel>
      )}
      <Select
        id={id}
        name={name}
        placeholder={placeholder}
        title={typeof title === "string" ? title : ""}
        backgroundColor="white"
        // borderRadius="none"
        marginBlockStart={1}
		multiple={multiple}
        _focus={{ borderColor: "lime", boxShadow: "0 0 0 1px var(--chakra-colors-lime)" }}
        {...rest}
        ref={ref}
      >
        {children}
      </Select>
      {error && <FormErrorMessage>{error?.message}</FormErrorMessage>}
    </FormControl>
  );
}

export default forwardRef(FormSelect);
